import React from 'react';
import { LocalPropertyValue } from '@cdaas/api-clients/dist/product-service-openapi';

const PropertiesText = ({ properties }: { properties: LocalPropertyValue[] | undefined }) => {
  if (!properties || properties.length === 0) {
    return null;
  }

  return (
    <>
      {properties.map((property, index) => (
        <span key={`prop ${property.id}`}>
          {index < properties.length && ' / '}
          {property.value}
        </span>
      ))}
    </>
  );
};

export default PropertiesText;
